import React, { useContext, useRef, useState } from 'react';
import { Body, Footer, Header, Main, closeAnimation } from '../../NecttosComp/Layout/Layout';
import Button from '../../NecttosComp/Button/Button';
import { getAxiosTokenInstance } from '../../utils/axiosInstance';
import { useQuery } from 'react-query';
import { FirebaseContext } from '../../context/FirebaseContext';
import { Table, Tbody, Td, Th, Thead, Tr } from '../../NecttosComp/Table/Table';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import Invoice from '../../NecttosComp/Invoice';
import Instruction from '../../Documentation/Instruction';

const getFieldDropDowns = (collegeId: any) => async () => {
	const instance = await getAxiosTokenInstance();
	try {
		const resp = await instance.get('/necttos/getNecttosInvoiceCalculator', {
			params: { collegeId },
		});
		if (resp.data.statusCode === 400) {
			throw new Error(resp.data.message || 'API Error');
		} else {
			return resp?.data?.yearWiseCounts;
		}
	} catch (error) {
		throw new Error('API Error');
	}
};

interface InvoiceManagementProps {
	onClose: () => void;
}

function NecttosInvoiceManagement({ onClose }: InvoiceManagementProps) {
	const [selectedBill, setSelectedBill] = useState<any>(null);
	const [showBillModal, setShowBillModal] = useState(false);
	const { collegeId } = useContext(FirebaseContext);
	const ref = useRef<any>(null);
	const billRef = useRef<any>(null);

	const { data: tableData = [] } = useQuery('getFieldDropDowns', getFieldDropDowns(collegeId));
	const data = Object.entries(tableData)
		.map(([year, value]) => ({ year, value }))
		.filter((x: any) => x?.value > 0);

	if (data.length === 0) return <Main title='Academic Holiday Management' width='90vw' height='90vh'></Main>;

	const generatePDF = () => {
		const doc = new jsPDF();
		doc.html(billRef.current, {
			callback: function (doc) {
				doc.save(`Invoice-NECTTOS-${selectedBill?.invoiceNumber}.pdf`);
			},
			x: 10,
			y: 10,
		});
	};
	return (
		<>
			<Main title='Necttos Invoice Management' width='90vw' height='90vh'>
				<Header>
					<div></div>
					<div className='flex'>
						<Button type='print' tableRef={ref.current}>
							Print
						</Button>
						<Button type='excel' tableRef={ref.current}>
							Excel
						</Button>
						<Instruction keyId={'necttosInvoiceManagement'}/>
						<Button type='close' onClick={onClose}>
							Close
						</Button>
					</div>
				</Header>
				<Body>
					<div ref={ref} className='h-[75vh] pt-2 printable overflow-auto'>
						<Table width='100%' innerWidth={['5%', '15%', '35%', '15%', '10%', '10%']}>
							<Thead>
								<Tr>
									<Th position={0}>Sl.No.</Th>
									<Th position={3}>Holiday</Th>
									<Th position={4}>Effected</Th>
									<Th position={5}>Managed By</Th>
									<Th position={6}>Action</Th>
								</Tr>
							</Thead>
							<Tbody height='auto'>
								{data?.map((x: any, i: number) => (
									<Tr key={i}>
										<Td index={i} position={0}>
											{i + 1}
										</Td>
										<Td index={i} position={3}>
											{x?.year}
										</Td>
										<Td index={i} position={4}>
											{x?.value}
										</Td>
										<Td index={i} position={5}>
											{x?.managedBy}
										</Td>
										<Td index={i} position={6}>
											<div className='flex'>
												<Button
													type='save'
													onClick={() => {
														setSelectedBill(x);
														setShowBillModal(true);
													}}>
													Bill
												</Button>
											</div>
										</Td>
									</Tr>
								))}
							</Tbody>
						</Table>
					</div>
				</Body>
			</Main>

			<Invoice showBillModal={showBillModal} setShowBillModal={setShowBillModal} selectedBill={{ invoiceNumber: 12345, managedBy: 'Mohsin', value: selectedBill?.value }} />
		</>
	);
}

export default NecttosInvoiceManagement;
